module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes_2019--8-67c45329.png";